import { mobileMatchMedia } from './common';

export default function header() {
  const headerLogo = document.getElementById('js-header-logo');

  const fixPosition = () => {
    if (!mobileMatchMedia.matches) {
      headerLogo.style.left = `-${window.pageXOffset}px`;
    }
  };
  const removePositon = () => {
    headerLogo.style.left = '';
  };

  window.addEventListener('scroll', () => {
    fixPosition();
  });
  fixPosition();
  mobileMatchMedia.addListener(removePositon);
}
